// Centralized API configuration
const API_CONFIG = {
  // Get base URL from environment variable, fallback for local development
  BASE_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000',
  // BASE_URL: 'http://192.168.20.68:5000',
  // API endpoints
  ADMIN_API_PATH: '/api/admin',
  MERCHANT_API_PATH: '/api/merchant',

  // Timeout settings - Increased for AI generation processing
  DEFAULT_TIMEOUT: 300000, // Increased from 2 minutes to 5 minutes for AI generation (5min)
  UPLOAD_TIMEOUT: 900000, // Increased from 30s to 2 minutes for batch uploads
  VIDEO_GENERATION_TIMEOUT: 1800000, // Increased from 10 minutes to 30 minutes for batch video generation
  BATCH_PROCESSING_TIMEOUT: 900000, // 15 minutes for batch image processing
};

// Computed URLs
export const API_URLS = {
  ADMIN_BASE: `${API_CONFIG.BASE_URL}${API_CONFIG.ADMIN_API_PATH}`,
  MERCHANT_BASE: `${API_CONFIG.BASE_URL}${API_CONFIG.MERCHANT_API_PATH}`,
  BACKEND_BASE: API_CONFIG.BASE_URL,
};

export const TIMEOUTS = {
  DEFAULT: API_CONFIG.DEFAULT_TIMEOUT,
  UPLOAD: API_CONFIG.UPLOAD_TIMEOUT,
  VIDEO_GENERATION: API_CONFIG.VIDEO_GENERATION_TIMEOUT,
  BATCH_PROCESSING: API_CONFIG.BATCH_PROCESSING_TIMEOUT,
};

export default API_CONFIG; 